var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.343506,
    width: 30,
    height: 24,
    rx: 12,
    fill: "#3FA80E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.467 13.7865C19.2413 13.674 18.1418 13.1363 17.937 13.062C17.7323 12.9862 17.5823 12.9495 17.4323 13.1745C17.2845 13.3958 16.854 13.8975 16.7243 14.046C16.593 14.1922 16.4625 14.2035 16.2398 14.1023C16.0148 13.9897 15.2925 13.7535 14.4375 12.9885C13.7715 12.3923 13.3245 11.661 13.1925 11.436C13.062 11.211 13.1783 11.0873 13.29 10.9748C13.392 10.8735 13.5158 10.716 13.6283 10.5825C13.7378 10.4467 13.7738 10.3568 13.851 10.2105C13.926 10.053 13.8878 9.92925 13.8323 9.8175C13.776 9.705 13.3283 8.6025 13.1408 8.163C12.9608 7.725 12.7755 7.7805 12.6368 7.7805C12.5078 7.76925 12.3585 7.76925 12.2085 7.76925C12.0585 7.76925 11.8163 7.82475 11.6108 8.0385C11.406 8.2635 10.827 8.8035 10.827 9.89475C10.827 10.986 11.6295 12.0435 11.7413 12.201C11.853 12.3472 13.32 14.5972 15.5663 15.5648C16.1018 15.7898 16.5188 15.9248 16.8443 16.0365C17.3798 16.2067 17.868 16.1827 18.2543 16.1273C18.6848 16.059 19.5795 15.5865 19.7663 15.0577C19.9575 14.529 19.9575 14.0903 19.9013 13.989C19.8458 13.8878 19.6988 13.8315 19.4738 13.7303M15.3893 19.3125H15.3773C14.0498 19.3125 12.7343 18.9525 11.586 18.2775L11.316 18.117L8.50351 18.8483L9.25726 16.1145L9.07801 15.8333C8.33551 14.6512 7.94101 13.29 7.94101 11.8883C7.94101 7.8045 11.2823 4.4745 15.3975 4.4745C17.388 4.4745 19.2563 5.25075 20.6633 6.657C22.0695 8.05125 22.845 9.9195 22.845 11.8995C22.842 15.9825 19.5 19.3132 15.3938 19.3132M21.7335 5.58675C20.0235 3.93375 17.7735 3 15.3773 3C10.4408 3 6.42151 7.0005 6.41926 11.9198C6.41926 13.4917 6.83101 15.0247 7.61551 16.3785L6.34351 21L11.0948 19.761C12.4043 20.4683 13.8773 20.844 15.3773 20.8463H15.3818C20.3205 20.8463 24.3413 16.8442 24.3435 11.9242C24.3435 9.54225 23.4135 7.3005 21.7223 5.616",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6.34351 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconGreen);
export default __webpack_public_path__ + "static/media/whatsappIconGreen.c980868f38614d27a7ea567420c717f4.svg";
export { ForwardRef as ReactComponent };